module.exports = __webpack_public_path__ + "static/media/hrPreviewDocumentImg.63c54f0a.png";